The partner organization making the request.
